export const blogPosts = [
  {
    id: 1,
    slug: 'how-to-choose-mortgage-track',
    title: 'איך לבחור את המסלול הנכון למשכנתא שלכם?',
    excerpt: 'מדריך מקיף להבנת סוגי המסלולים השונים והתאמתם לצרכים האישיים שלכם.',
    date: '15 במרץ 2024',
    category: 'משכנתא חדשה',
    categorySlug: 'new-mortgage',
    image: '/images/blog/mortgage-paths.jpg',
    metaDescription: 'גלו איך לבחור את מסלול המשכנתא המתאים לכם ביותר. מדריך מקיף על מסלולי פריים, קבועה ומשתנה.',
    content: `
      <h2>הקדמה לבחירת מסלולי משכנתא</h2>
      <p>בחירת מסלולי משכנתא היא אחת ההחלטות הפיננסיות המשמעותיות ביותר שתקבלו בחייכם. התמהיל הנכון (או בשפה המקצועית - "תמהיל המשכנתא") יכול לחסוך לכם מאות אלפי שקלים לאורך תקופת ההלוואה. חשוב להבין שאין תמהיל אחד שמתאים לכולם; מה שמתאים לזוג צעיר בתחילת דרכו עם צפי לעליית שכר, לאו דווקא יתאים למשפחה עם הוצאות קבועות גבוהות.</p>
      
      <p>לפני שצוללים למסלולים, כדאי להשתמש ב<a href="/calculator">מחשבון המשכנתא המתקדם</a> שלנו כדי לקבל מושג ראשוני על ההחזרים הצפויים.</p>

      <h3>מסלול הפריים (Prime)</h3>
      <p>זהו המסלול הנפוץ ביותר בישראל. הריבית בו מבוססת על ריבית בנק ישראל (כיום עומדת על 4.5% בתוספת מרווח של 1.5% קבוע). היתרון הגדול הוא שאין עמלות פירעון מוקדם (קנסות), מה שמאפשר גמישות מקסימלית בביצוע <a href="/blog/refinance-tips">מיחזור משכנתא</a> בעתיד. החיסרון הוא התנודתיות - כל שינוי בריבית בנק ישראל משפיע מיידית על ההחזר החודשי שלכם.</p>
      
      <h3>ריבית קבועה לא צמודה (קל"צ)</h3>
      <p>מסלול המעניק לכם שקט נפשי מלא. ההחזר החודשי ידוע מראש ואינו משתנה לעולם, ללא קשר לאינפלציה או לשינויי ריבית במשק. זהו "עוגן" התמהיל שלכם. הוא בדרך כלל יקר יותר ממסלולים משתנים ביום הלקיחה, אך הוא מגן עליכם מפני הפתעות לא נעימות בעתיד.</p>
      
      <h3>ריבית משתנה כל 5 שנים (צמודה או לא צמודה)</h3>
      <p>מסלול המאפשר לכם נקודות יציאה ללא קנסות כל חמש שנים. מתאים למי שמתכנן לפרוע חלק מהמשכנתא בטווח הבינוני (למשל פתיחת קרן השתלמות). במסלול זה הריבית משתנה לפי "עוגן" (כמו תשואות אג"ח ממשלתיות).</p>
      
      <h3>איך מחליטים?</h3>
      <p>בניית תמהיל נכון דורשת הבנה עמוקה של השוק ושל המצב האישי שלכם. אנחנו ממליצים לשלב לפחות 3 מסלולים שונים כדי לפזר סיכונים. אם אתם מרגישים מבולבלים, אל תהססו <a href="/contact">ליצור איתנו קשר לייעוץ ראשוני</a>.</p>

      <h3>טיפ זהב</h3>
      <p>אל תסתכלו רק על הריבית ביום הראשון. תבדקו איך ההחזר החודשי ייראה אם הריבית תעלה ב-1% או אם המדד יעלה. תכנון נכון היום ימנע משברים כלכליים מחר.</p>
    `
  },
  {
    id: 2,
    slug: 'refinance-tips',
    title: 'טיפים חשובים למיחזור משכנתא',
    excerpt: 'כל מה שצריך לדעת לפני שמחליטים למחזר את המשכנתא הקיימת.',
    date: '10 במרץ 2024',
    category: 'מיחזור משכנתא',
    categorySlug: 'refinance',
    image: '/images/blog/refinance-tips.jpg',
    metaDescription: 'שוקלים למחזר משכנתא? קבלו את הטיפים המקצועיים שיעזרו לכם לחסוך כסף ולשפר את תנאי ההחזר שלכם.',
    content: `
      <h2>מתי כדאי למחזר משכנתא?</h2>
      <p>מיחזור משכנתא הוא תהליך שבו מחליפים משכנתא קיימת בחדשה, בתנאים טובים יותר. המטרה היא בדרך כלל להוריד את הריבית הכוללת, לשנות את גובה ההחזר החודשי או לקצר את תקופת ההלוואה. במקרים מסוימים, ניתן גם לבצע <a href="/blog/loan-consolidation-guide">איחוד הלוואות</a> כחלק מתהליך המיחזור.</p>
      
      <h3>הסימנים שהגיע הזמן למחזר</h3>
      <ol>
        <li><strong>ירידת ריביות בשוק:</strong> אם הריביות היום נמוכות משמעותית ממה שקיבלתם כשלקחתם את המשכנתא, יש פוטנציאל חיסכון אדיר.</li>
        <li><strong>שינוי במצב הכלכלי:</strong> עלייה בשכר מאפשרת הגדלת החזר וקיצור שנים (מה שחוסך המון ריבית), או לחילופין, צורך בהקטנת החזר בגלל הוצאות משפחתיות גדלות.</li>
        <li><strong>עליית ערך הנכס:</strong> אם הבית שלכם שווה היום הרבה יותר, אחוז המימון שלכם ירד, מה שמאפשר לבנקים לתת לכם ריביות של "לקוחות מועדפים".</li>
      </ol>
      
      <h3>המלכודת: עמלות פירעון מוקדם</h3>
      <p>לפני שרצים למחזר, חייבים להוציא מהבנק "דו"ח יתרות לסילוק". שם תראו אם יש לכם קנסות (עמלות היוון). לעיתים הקנס כל כך גבוה שהוא "אוכל" את כל החיסכון מהריבית הנמוכה. כאן נכנס התפקיד שלי כיועצת - לבצע חישוב כדאיות מדויק. לפעמים משתלם לשלם קנס של 20,000 ש"ח כדי לחסוך 100,000 ש"ח בריביות לאורך זמן.</p>
      
      <h3>תהליך המיחזור</h3>
      <p>התהליך דומה מאוד ללקיחת משכנתא חדשה. אתם יכולים למחזר באותו בנק (מיחזור פנימי) או לעבור לבנק אחר (מיחזור חיצוני) אם הוא מציע תנאים טובים יותר. אנחנו ב"אפיק לב" ננהל עבורכם את המשא ומתן מול כל הגופים הפיננסיים כדי להשיג את התוצאה המקסימלית.</p>
      
      <p>רוצים לדעת אם כדאי לכם למחזר? <a href="/contact">שלחו לנו הודעה בוואטסאפ</a> עם יתרת המשכנתא הנוכחית שלכם ונבצע בדיקה ראשונית ללא עלות.</p>
    `
  },
  {
    id: 3,
    slug: 'loan-consolidation-guide',
    title: 'איחוד הלוואות - האם זה מתאים לכם?',
    excerpt: 'הסבר מפורט על היתרונות והחסרונות של איחוד הלוואות.',
    date: '5 במרץ 2024',
    category: 'כלכלת המשפחה',
    categorySlug: 'family-finance',
    image: '/images/blog/loan-consolidation.jpg',
    metaDescription: 'מרגישים חנוקים מהלוואות? איחוד הלוואות לתוך המשכנתא עשוי להיות הפתרון המושלם עבורכם. קראו את המדריך.',
    content: `
      <h2>מה זה איחוד הלוואות?</h2>
      <p>איחוד הלוואות הוא תהליך פיננסי שבו לוקחים הלוואה אחת גדולה (בדרך כלל כנגד נכס נדל"ן שבבעלותכם) כדי לסגור מספר רב של הלוואות קטנות, יקרות ומעיקות. מדובר על הלוואות לרכב, חובות בכרטיסי אשראי, הלוואות "לכל מטרה" מהבנק ואפילו חובות חוץ-בנקאיים.</p>
      
      <p>אם אתם מתכננים לקנות נכס חדש ובמקביל לסגור חובות, מומלץ לקרוא קודם על <a href="/blog/how-to-choose-mortgage-track">בחירת מסלולי משכנתא</a> כדי להבין איך לשלב את הכל יחד.</p>

      <h3>למה זה כל כך פופולרי?</h3>
      <p>הסיבה המרכזית היא <strong>תזרים המזומנים</strong>. הלוואות רגילות ניתנות בדרך כלל לתקופות קצרות (3-7 שנים) בריביות גבוהות (8%-15%). לעומת זאת, הלוואה כנגד נכס ניתן לפרוס ל-20 או 30 שנה בריביות של משכנתא (שהן נמוכות משמעותית). התוצאה? החזר חודשי שיכול לרדת מ-8,000 ש"ח ל-3,000 ש"ח בלבד, מה שמאפשר למשפחה "לנשום" ולחזור לאיזון כלכלי.</p>
      
      <h3>הסיכונים שחשוב להכיר</h3>
      <ul>
        <li><strong>עלות כוללת:</strong> כשפורסים חוב ל-30 שנה, משלמים עליו ריבית לאורך הרבה מאוד זמן. בסוף הדרך, ייתכן שתשלמו יותר שקלים על הריבית מאשר בהלוואה הקצרה.</li>
        <li><strong>מישכון הנכס:</strong> אתם בעצם הופכים חוב "רגיל" לחוב שמגובה בבית שלכם. זה צעד שדורש אחריות גבוהה מאוד.</li>
        <li><strong>חזרה להרגלים ישנים:</strong> איחוד הלוואות הוא פלסטר. אם לא תשנו את התנהלות כלכלת המשפחה שלכם, אתם עלולים למצוא את עצמכם עם משכנתא מוגדלת ועם הלוואות חדשות בתוך שנה.</li>
      </ul>
      
      <h3>מתי אנחנו ממליצים על איחוד?</h3>
      <p>כאשר הריביות על החובות הקיימים הן "ריביות נשך", וכאשר ההחזר החודשי הנוכחי מונע מהמשפחה להתנהל בצורה תקינה וגורם לחריגות בחשבון. אנחנו מלווים אתכם גם בצד הטכני של השגת הכסף וגם בבניית תוכנית הבראה כלכלית אמיתית.</p>
      
      <p>רוצים לבדוק את האופציות שלכם? <a href="/contact">צרו איתנו קשר</a> ונתחיל לבחון את הנתונים.</p>
    `
  },
  {
    id: 4,
    slug: 'mortgage-for-rejected-buyers',
    title: 'מדריך למסורבי משכנתא - יש מה לעשות!',
    excerpt: 'קיבלתם תשובה שלילית מהבנק? אל תתייאשו. יש פתרונות יצירתיים.',
    date: '1 במרץ 2024',
    category: 'טיפים ומידע',
    categorySlug: 'tips',
    image: '/images/blog/mortgage-solutions.jpg',
    metaDescription: 'סורבתם על ידי הבנק? גלו איך ניתן להפוך את הלא לכן. פתרונות למסורבי משכנתא, שיפור דירוג אשראי וליווי מקצועי.',
    content: `
      <h2>למה הבנק אמר "לא"?</h2>
      <p>קבלת סירוב למשכנתא יכולה להיות חוויה מתסכלת ומלחיצה, במיוחד אם כבר מצאתם את דירת החלומות שלכם. הבנקים מסרבים בדרך כלל משלוש סיבות עיקריות: בעיות בטיב הלקוח (BDI שלילי), חוסר ביכולת החזר, או בעיות משפטיות/תכנוניות בנכס עצמו.</p>
      
      <h3>צעד ראשון: בדיקת נתוני האשראי</h3>
      <p>לפני הכל, צריך להבין מה רשום עליכם במערכת נתוני האשראי של בנק ישראל. לעיתים מדובר בטעות קטנה או בחוב ישן שנשכח וניתן להסדיר. <a href="/blog/improve-credit-rating">שיפור דירוג האשראי</a> הוא תהליך שאנחנו מתמחים בו.</p>
      
      <h3>פתרונות אפשריים</h3>
      <ul>
        <li><strong>הוספת ערב תומך:</strong> הורים או אחים שיכולים להצטרף להלוואה ולחזק את יכולת ההחזר.</li>
        <li><strong>פנייה לגופים חוץ-בנקאיים:</strong> חברות ביטוח וגופי מימון אחרים לפעמים גמישים יותר מהבנקים (אם כי הריבית תהיה מעט גבוהה יותר).</li>
        <li><strong>הסדרת חובות ושיפור ה-BDI:</strong> הגשת בקשה לתיקון מידע או פשוט המתנה של תקופה מסוימת תוך התנהלות מופתית בחשבון.</li>
      </ul>
      
      <p>זכרו ש"לא" מבנק אחד הוא לא בהכרח "לא" מכל המערכת. עם הכנה נכונה והצגת הנתונים בצורה מקצועית, הצלחנו להשיג משכנתאות לאלפי לקוחות שסורבו בתחילה.</p>
      <p>אל תלכו לבנק לבד אחרי סירוב. <a href="/contact">פנו אלינו עכשיו</a> לטיפול דחוף בתיק שלכם.</p>
    `
  },
  {
    id: 5,
    slug: 'mortgage-for-self-employed',
    title: 'משכנתא לעצמאיים - המדריך המלא להצלחה',
    excerpt: 'עצמאיים? הבנק מסתכל עליכם אחרת. גלו איך להציג את הנתונים נכון.',
    date: '25 בפברואר 2024',
    category: 'טיפים ומידע',
    categorySlug: 'tips',
    image: '/images/blog/bank-meeting.jpg',
    metaDescription: 'מדריך משכנתא לעצמאיים: איך הבנק מחשב הכנסה, אילו מסמכים צריך ואיך לעבור את התהליך בקלות.',
    content: `
      <h2>למה לעצמאיים קשה יותר לקבל משכנתא?</h2>
      <p>בניגוד לשכירים, שאצלם התלוש מדבר בעד עצמו, אצל עצמאיים הבנק חושש מחוסר יציבות. הבנק לא מסתכל על המחזור שלכם, אלא על השורה התחתונה בדו"ח השומה - הרווח הנקי לאחר הוצאות.</p>
      
      <h3>איך הבנק מחשב את ההכנסה שלכם?</h3>
      <p>בדרך כלל הבנק יבקש דו"חות שומה של השנתיים האחרונות פלוס אישור רואה חשבון על ההכנסות בשנה השוטפת. הבנק מבצע ממוצע של ההכנסות האלו כדי להחליט מהי "יכולת ההחזר" שלכם.</p>
      
      <h3>טיפים לעצמאיים לפני לקיחת משכנתא:</h3>
      <ul>
        <li><strong>תכנון מוקדם:</strong> אם אתם מתכננים לקנות בית בשנה הבאה, כדאי להתייעץ עם רואה החשבון ולוודא שהשומה שלכם משקפת את הרווח האמיתי ולא רק מנסה "לחסוך במס".</li>
        <li><strong>הפרדת חשבונות:</strong> מומלץ מאוד להפריד בין חשבון העסק לחשבון הפרטי כדי להראות התנהלות מסודרת.</li>
        <li><strong>הצגת פוטנציאל:</strong> אם העסק בצמיחה מהירה, חשוב להציג את זה לבנק בצורה מנומקת.</li>
      </ul>
      
      <p>אנחנו ב"אפיק לב" מומחים ב"תרגום" הנתונים של עצמאיים לשפה שהבנק מבין ואוהב. לפרטים נוספים, בדקו את ה<a href="/services">שירותים שלנו</a>.</p>
    `
  },
  {
    id: 6,
    slug: 'reverse-mortgage-explained',
    title: 'משכנתא הפוכה - פתרון פיננסי חכם לגיל השלישי',
    excerpt: 'איך הבית שלכם יכול לייצר לכם הכנסה חודשית קבועה בפרישה.',
    date: '20 בפברואר 2024',
    category: 'טיפים ומידע',
    categorySlug: 'tips',
    image: '/images/blog/market-updates.jpg',
    metaDescription: 'מהי משכנתא הפוכה? גלו איך בני 60 ומעלה יכולים לקבל כסף מהנכס שלהם ללא החזר חודשי שוטף.',
    content: `
      <h2>מהי משכנתא הפוכה?</h2>
      <p>משכנתא הפוכה היא הלוואה המיועדת לבני 60 ומעלה שבבעלותם נכס נדל"ן. בניגוד למשכנתא רגילה, כאן הלווה לא חייב לשלם החזר חודשי שוטף (למרות שניתן לעשות זאת). ההלוואה מוחזרת רק בעת מכירת הנכס או לאחר פטירת הלווה.</p>
      
      <h3>למי זה מתאים?</h3>
      <p>הפתרון הזה אידיאלי עבור פנסיונרים שרוצים לשדרג את רמת החיים, לעזור לילדים ברכישת דירה, או לממן הוצאות רפואיות ומגורים בדיור מוגן, מבלי לעזוב את הבית שלהם.</p>
      
      <h3>היתרונות המרכזיים:</h3>
      <ul>
        <li>אין צורך בביטוח חיים.</li>
        <li>אין צורך להציג יכולת החזר או הכנסות חודשיות.</li>
        <li>הבית נשאר בבעלותכם המלאה.</li>
        <li>ניתן לפרוע את ההלוואה בכל עת ללא קנסות.</li>
      </ul>
      
      <p>לפני שעושים צעד כזה, חשוב להתייעץ עם כל המשפחה. אתם מוזמנים ל<a href="/contact">תיאום פגישת ייעוץ משפחתית</a> אצלנו במשרד.</p>
    `
  },
  {
    id: 7,
    slug: 'improve-credit-rating',
    title: 'איך לשפר את דירוג האשראי (BDI) שלכם?',
    excerpt: 'המדריך המעשי לתיקון נתוני אשראי וקבלת אישור למשכנתא.',
    date: '15 בפברואר 2024',
    category: 'טיפים ומידע',
    categorySlug: 'tips',
    image: '/images/blog/mortgage-solutions.jpg',
    metaDescription: 'דירוג האשראי שלכם נמוך? אל תדאגו. למדו איך לקרוא את דו"ח ה-BDI ואיך לשפר את הדירוג כדי לקבל משכנתא בתנאים מעולים.',
    content: `
      <h2>דירוג אשראי - תעודת הזהות הפיננסית שלכם</h2>
      <p>מאז כניסת חוק נתוני האשראי, הבנקים יודעים עליכם הכל. כל צ'ק שחזר, כל הוראת קבע שבוטלה וכל איחור בתשלום הלוואה נרשמים במערכת ומשפיעים על הדירוג שלכם.</p>
      
      <h3>איך משפרים את המצב?</h3>
      <ol>
        <li><strong>הזמנת דו"ח ריכוז נתונים:</strong> קודם כל, הבינו מה הבעיה. ניתן להזמין את הדו"ח בחינם פעם בשנה מאתר בנק ישראל.</li>
        <li><strong>תיקון טעויות:</strong> אם מצאתם מידע שגוי (חוב ששולם ועדיין מופיע כפתוח), פנו מיידית לחברת הדירוג לתיקון המידע.</li>
        <li><strong>התנהלות מופתית:</strong> הבנק מסתכל בעיקר על החצי שנה האחרונה. וודאו שאין חריגות, שכל התשלומים עוברים בזמן וצמצמו ניצול של מסגרות אשראי.</li>
      </ol>
      
      <p>שיפור הדירוג לוקח זמן, אבל הוא שווה זהב. דירוג גבוה יותר משמעותו ריביות נמוכות יותר שיכולות לחסוך לכם עשרות אלפי שקלים. למידע נוסף על פתרונות יצירתיים, קראו את ה<a href="/blog/mortgage-for-rejected-buyers">מדריך למסורבי משכנתא</a> שלנו.</p>
    `
  }
];

export const categories = [
  { name: 'הכל', slug: 'all' },
  { name: 'משכנתא חדשה', slug: 'new-mortgage' },
  { name: 'מיחזור משכנתא', slug: 'refinance' },
  { name: 'כלכלת המשפחה', slug: 'family-finance' },
  { name: 'טיפים ומידע', slug: 'tips' }
];
